import { cn } from 'cn';
import { useEnvironment } from '@/app/environment';
import { Skeleton } from '@/components/ui/skeleton';
import { WIDTH_CLASS, useShell } from './context';

export const SEP = ' · ';

/** One static 12 px line at the end of main: region, Bedrock profile, environment, build. */
export function FooterLine({ className }: { className?: string }) {
  const env = useEnvironment();
  const { width } = useShell();
  return (
    <footer className={cn('mx-auto w-full px-4 pt-6 pb-4 text-xs text-beam-text-muted md:px-6', WIDTH_CLASS[width], className)}>
      {env.data ? (
        <p className="tabular">
          {[env.data.region, `Bedrock ${env.data.bedrockProfile}`, env.data.env, `build ${env.data.build}`].join(SEP)}
        </p>
      ) : (
        <Skeleton className="h-4 w-80" aria-hidden="true" />
      )}
    </footer>
  );
}
